export const GET_UING_REQUEST = "GET_UING_REQUEST"
export const GET_UING_SUCCESS = "GET_UING_SUCCESS"
export const GET_UING_FAILED = "GET_UING_FAILED"
export const GET_UING_CSV_REQUEST = "GET_UING_CSV_REQUEST"
export const GET_UING_CSV_SUCCESS = "GET_UING_CSV_SUCCESS"
export const GET_UING_CSV_FAILED = "GET_UING_CSV_FAILED"

export const GetUserInfoNG = (value:any)=>{
    return{
        type:GET_UING_REQUEST,payload: value
    }
}

// export const GetUserInfoNGCSV = (csvData: any, formData: FormData)=>{
//     return{
//         type:GET_UING_CSV_REQUEST,payload: { csvData, formData }
//     }
// }